





































import { defineComponent, ref } from '@vue/composition-api';
import { NotificationContractIcon } from '../icons';

export default defineComponent({
    name: 'ContractDigest',
    components: { NotificationContractIcon },
    props: {
        notification: {
            type: Array,
            required: true,
        },
    },
    setup() {
        const isHovered = ref(false);

        const getContractTitle = (contractType: string) => {
            let title = '';
            switch (contractType) {
                case 'contract.created':
                    title = 'Contracts that were created and involve your Organization: ';
                    break;
                case 'contract.accepted':
                    title = ' Contracts that were accepted and involve your Organization: ';
                    break;
                case 'contract.rejected':
                    title = 'Contracts that were rejected and involve your Organization: ';
                    break;
                case 'contract.activated':
                    title = 'Contracts that became active and involve your Organization: ';
                    break;
                case 'contract.negotiation':
                    title = 'Contracts under negotiation and involve your Organization: ';
                    break;
                case 'contract.extended':
                    title = 'Contracts that were extended and involve your Organization: ';
                    break;
                case 'contract.revised':
                    title = 'Contracts that were revised and involve your Organization: ';
                    break;
                case 'contract.reactivated':
                    title = 'Contracts that were reactivated and involve your Organization: ';
                    break;
                case 'contract.draft.signed':
                    title = 'Draft Contracts sent to your Organization for datasets you are interested to acquire: ';
                    break;
                case 'contract.bundle.rejected':
                    title = 'Bundle contracts that were rejected and involves your Organisation: ';
                    break;
                case 'contract.bundle.activated':
                    title = 'Bundle contracts that were activated and involves your Organisation: ';
                    break;
                case 'contract.derivation.created':
                    title = 'Derivation contracts that were created and involve your Organization: ';
                    break;
                case 'contract.derivation.accepted':
                    title = 'Derivation contracts that were accepted and involve your Organization: ';
                    break;
                case 'contract.derivation.rejected':
                    title = 'Derivation contracts that were rejected and involve your Organization: ';
                    break;
                case 'contract.derivation.withdraw':
                    title =
                        'Derivation contracts that were rejected by other organisations and involve your Organization: ';
                    break;
                case 'contract.derivation.negotiation':
                    title = 'Derivation contracts under negotiation and involve your Organization: ';
                    break;
                case 'contract.derivation.draft.signed':
                    title =
                        'Draft Derivation Contracts sent to your Organization for datasets you are interested to acquire: ';
                    break;
                case 'contract.derivation.available':
                    title = ' Derivation contract assets that are available in marketplace: ';
                    break;
                case 'contract.derivation.reimbursed':
                    title = ' Derivation contract assets that reimbursed you: ';
                    break;
                default:
                    break;
            }
            return title;
        };

        const getUrl = (key: string, contract: any) => {
            return { name: 'contract-details', params: { id: contract.payload.contractId, type: 'details' } };
        };

        const getContractMessage = (contract: any) => {
            let contractRelationVerb = '';
            let contracRelation = '';

            if (contract.payload.consumerOrgId === contract.payload.organisationId) {
                contractRelationVerb = 'Acquisition';
                contracRelation = 'from';
            } else {
                contractRelationVerb = 'Sharing';
                contracRelation = 'with';
            }
            const contractMessage = {
                contractId: contract.payload.contractId,
                verb: contractRelationVerb,
                relation: contracRelation,
                noun: contract.payload.organisationId
                    ? `organisation ${contract.payload.organisation.legalName}`
                    : `user ${contract.payload.user.firstName} ${contract.payload.user.lastName}`,
                endPhrase: '',
            };

            return { ...contractMessage };
        };

        return {
            isHovered,
            getContractTitle,
            getContractMessage,
            getUrl,
        };
    },
});
